import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    margin: '35px 44px 17px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerStatusWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  headerTitleWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    minWidth: '0px'
  },
  headerTitle: {
    color: '#335977',
    fontSize: '38px',
    display: 'block',
    fontWeight: 'bold',
    marginRight: '10px',
    maxWidth: '720px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  actionButton: {
    marginLeft: 'auto'
  },
  endEventPopWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '34px 30px'
  },
  infoContent: {
    color: '#565657',
    fontSize: '20px',
    textAlign: 'center',
    fontWeight: 'bold',
    marginTop: '10px'
  },
  infoNote: {
    margin: '20px',
    fontSize: '16px',
    color: '#565657',
    textAlign: 'center'
  },
  popupContent: {
    color: '#565657',
    fontSize: '20px',
    textAlign: 'center'
  },
  buttonGroup: {
    display: 'flex',
    width: '60%',
    justifyContent: 'space-between',
    marginTop: '25px',

    '& button': {
      width: '45%',
      minHeight: '36px',
      textTransform: 'capitalize',
      margin: 0
    }
  },
  contentWrapper: {
    border: '1px solid #70707033',
  },
  contentTitle: {
    color: '#F37320',
    fontSize: '12px',
    background: '#F7F7F7',
    height: '34px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 15px',
    fontWeight: 500
  },
  cardWrapper: {
    margin: '0 40px 40px',
    padding: '30px'
  },
  highlightWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '25px',
    justifyContent: 'space-between',

    '@media (max-width: 767px)': {
      flexDirection: 'column'
    }
  },
  highlightRow: {
    display: 'flex',
    width: '45%',
    justifyContent: 'space-between',
    margin: '5px 0',

    '@media (max-width: 767px)': {
      width: '100%'
    }
  },
  highlightLabel: {
    width: '120px',
    color: '#6F6F6F',
    fontSize: '14px',
    opacity: '60%'
  },
  highlightValue: {
    width: '50%',
    color: '#6F6F6F',
    fontWeight: 600,
    fontSize: '14px',
    textAlign: 'right'
  },
  optin: {
    border: '1px solid #E37939',
    height: '10px',
    width: '10px',
    background: '#E37939',
    borderRadius: '50%'
  },
  optout: {
    border: '1px solid #6D6C5F',
    height: '10px',
    width: '10px',
    background: '#6D6C5F',
    borderRadius: '50%'
  },
  marker: {
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center'
  },
  legendMarker: {
    textAlign: 'center'
  },
  mapWrapper: {
    height: '30em',

    '@media (min-width: 768px)': {
      margin: '1.25em 1.8em 2.5em 3.12em',
    }
  },
  dot: {
    height: '12px',
    width: '12px',
    marginRight: '5px'
  },
  flex: {
    display: 'flex'
  },
  mapDotWrapper: {
    margin: 'auto',
    textAlign: 'center',

    '@media (max-width: 767px)': {
      flexDirection: 'column',
    },

    '@media (min-width: 768px)': {
      width: '50%'
    }
  },
  mapDotContainer: {
    width: 'inherit',
    whiteSpace: 'nowrap',

    '@media (max-width: 767px)': {
      marginTop: '10px'
    }
  },
  icon: {
    '& svg': {
      width: '100px',
      height: '100px'
    }
  },
  arrow: {
    color: '#fff'
  },
  popper: {
    pointerEvents: 'auto'
  },
  tooltip: {
    backgroundColor: '#fff',
    padding: '15px'
  },
  tooltipWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '300px',
    zIndex: 4
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '6px'
  },
  label: {
    color: '#6F6F6F',
    fontSize: '14px',
    opacity: '0.6'
  },
  value: {
    color: '#6F6F6F',
    fontSize: '14px',
  },
  viewDetails: {
    cursor: 'pointer',
    marginTop: '8px',
    color: '#026AE3',
    fontSize: '16px',
    textAlign: 'center'
  },
  eyeIcon: {
    cursor: 'pointer',
    fontSize: '20px'
  },
  tableCenter: {
    textAlign: 'center'
  },
  link: {
    color: '#026AE3',
    cursor: 'pointer'
  },
  infoBox: {
    boxShadow: '0px 0px 6px #00000029',
    padding: '16px',
    margin: '16px',
    //width: '45%',
    '@media (min-width: 800px)': {
      //minWidth: '530px'
    }
  },
  energyInfoHeading: {
    color: '#387AD5',
    fontSize: '22px',
    margin: '5px 0'
  },
  powerInfoHeading: {
    color: '#F09035',
    fontSize: '22px',
    margin: '5px 0'
  },
  infoSubheading: {
    color: '#9F9E9E',
    fontSize: '12px',
    fontWeight: 500,
    margin: '5px 0'
  },

  //Graph CSS
  graphContainer: {
    position: 'relative',
    '& .rv-xy-plot__axis__title': {
      color: '#6F6F6F',
      fontSize: '12px',
      transform: 'translate(10px, 70px)',
    },
    '& .rv-xy-plot__axis__tick__text': {
      '@media(max-width: 900px)': {
        // transform: 'translate(0px, 14px) rotate(-45deg)',
        // textAnchor: 'end',
      }
    }
  },
  graphWrapper: {
    position: 'relative',
    cursor: 'pointer',
    '& .rv-xy-plot__axis__title': {
      color: '#6F6F6F',
      fontSize: '12px',
      transform: 'translate(10px, 70px)',
    },

    '& .rv-xy-plot__axis__tick__line': {
      display: 'none'
    },
  },
  crossHair: {
    zIndex: 2,
    position: 'absolute',

    '& .rv-crosshair__line': {
      background: 'rgba(123, 135, 147, 0.3)',
      width: '2px',
      height: '540px',

      '&::before': {
        content: "",
        position: 'absolute',
        top: 0,
        left: '-6px',
        borderColor: '#f7f8fc transparent transparent',
        borderStyle: 'solid',
        borderWidth: '8px 6px 0',
        filter: 'drop-shadow(0 0 1px #9d9d9d)'
      },

      '&::after': {
        content: "",
        position: 'absolute',
        bottom: 0,
        left: '-6px',
        borderColor: 'transparent transparent #f7f8fc',
        borderStyle: 'solid',
        borderWidth: '0 6px 8px',
        filter: 'drop-shadow(0 0 1px #9d9d9d)'
      }
    },

    '& .rv-crosshair__inner': {
      marginRight: '2px',
      zIndex: 2,

      '&::before': {
        content: "",
        position: 'absolute',
        top: '10px',
        right: '-5px',
        borderColor: 'transparent transparent transparent #d5dadd',
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 5px'
      },

      '&::after': {
        content: "",
        position: 'absolute',
        top: '10px',
        right: '-4px',
        borderColor: 'transparent transparent transparent #ffffff',
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 5px'
      }
    },
    '& .rv-crosshair__inner--right': {
      '& .custom-hintbox': {
        left: '2%',
      }
    },

    '& .rv-crosshair__inner--left': {
      '& .custom-hintbox': {
        right: '2%',
      }
    },
  },
  hint: {
    zIndex: 99,
    position: 'absolute',

    '& .rv-crosshair__line': {
      background: 'rgba(123, 135, 147, 0.3)',
      width: '2px',

      '&::before': {
        content: "",
        position: 'absolute',
        top: 0,
        left: '-6px',
        borderColor: '#f7f8fc transparent transparent',
        borderStyle: 'solid',
        borderWidth: '8px 6px 0',
        filter: 'drop-shadow(0 0 1px #9d9d9d)'
      },

      '&::after': {
        content: "",
        position: 'absolute',
        bottom: 0,
        left: '-6px',
        borderColor: 'transparent transparent #f7f8fc',
        borderStyle: 'solid',
        borderWidth: '0 6px 8px',
        filter: 'drop-shadow(0 0 1px #9d9d9d)'
      }
    },

    '& .rv-crosshair__inner': {
      marginRight: '2px',
      zIndex: 2,

      '&::before': {
        content: "",
        position: 'absolute',
        top: '10px',
        right: '-5px',
        borderColor: 'transparent transparent transparent #d5dadd',
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 5px'
      },

      '&::after': {
        content: "",
        position: 'absolute',
        top: '10px',
        right: '-4px',
        borderColor: 'transparent transparent transparent #ffffff',
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 5px'
      }
    },
  },
  hintCard: {
    width: '180px',
    padding: '5px 10px 5px',

    background: '#ffffff',
    color: '#000000',
    boxShadow: '0px 3px 6px #00000029',
    border: '1px solid #d7dbde',
    top: '20%',
    margin: '0 10px',
    position: 'absolute',
  },
  hintTextWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '5px',

    '& p': {
      fontSize: '12px'
    }
  },
  cardHeading: {
    fontFamily: 'Roboto',
    fontSize: '10px',
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.5px',
    color: 'rgba(123, 135, 147, 0.8)',
    marginBottom: '2px',
    textTransform: 'uppercase',
    textAlign: 'center'
  },
  cardKey: {
    color: '#6F6F6F',
    fontSize: '12px'
  },
  cardValue: {
    fontWeight: 'bold',
    color: '#6F6F6F',
    fontSize: '12px'
  },
  seriesLabel: {
    fontSize: '10px',
    color: '#707070'
  },
  eventViewerPopupContainer: {
    minHeight: '600px',
    width: '100%',
    padding: '0',
  },
}))

export { useStyles }